<template>
  <div
    class="wrapper_dark"
    @click="interactCheck"
    @touchstart="interactCheck"
    @touchmove="interactCheck"
  >
    <div class="header">
      <button class="btn_back" @click="back">
        <img src="@/assets/img/left-arrow.svg" />
      </button>
      <h1 class="title">{{ $tc("Accept_the_terms") }}</h1>
    </div>
    <div class="inner_wrap">
      <div class="terms_warp">
        <div class="check_box_list_wrap">
          <ul class="check_box_list">
            <li class="all_agree" @click="handleingAgree('allAgree')">
              <div class="check-box" :class="{ active: allAgree }"></div>
              <div class="agree_str" v-html="$tc('all_agree')"></div>
            </li>
            <li @click="handleingAgree('agree1', 0)">
              <div
                class="check-box"
                :class="{ active: agreeList[0].value }"
              ></div>
              <div class="agree_str" v-html="$tc('tabling_agree')"></div>
            </li>
            <li @click="handleingAgree('agree2', 1)">
              <div
                class="check-box"
                :class="{ active: agreeList[1].value }"
              ></div>
              <div class="agree_str" v-html="$tc('store_agree')"></div>
            </li>
            <li @click="handleingAgree('agree3', 2)">
              <div
                class="check-box"
                :class="{ active: agreeList[2].value }"
              ></div>
              <div class="agree_str" v-html="$tc('event_agree')"></div>
            </li>
            <li v-if="!isHidePartnerAgree" @click="handleingAgree('agree4', 3)">
              <div
                class="check-box"
                :class="{ active: agreeList[3].value }"
              ></div>
              <div class="agree_str" v-html="$tc('partner_info_agree')"></div>
            </li>
            <li v-if="!isHidePartnerAgree" @click="handleingAgree('agree5', 4)">
              <div
                class="check-box"
                :class="{ active: agreeList[4].value }"
              ></div>
              <div class="agree_str" v-html="$tc('partner_ad_agree')"></div>
            </li>
          </ul>
        </div>
        <div v-if="locale === 'ko'" class="terms">
          <div>
            <p>
              예약 서비스 제공을 위해서
              <span>테이블링 주식회사 및 예약을 신청한 매장</span>에서 다음과
              같이 개인정보를 수집·이용하고 있습니다.
            </p>
            <br />
            <p class="title">(필수) 만14세 이상임을 확인합니다.</p>
            <p>
              만14세 미만 아동의 개인정보 보호를 위하여 만14세 미만 아동의
              이용을 제한하고 있습니다. 만14세미만 아동은 본 서비스를 이용하실
              수 없습니다.
            </p>
            <br />
            <p class="title">(필수) ‘테이블링’의 개인정보 수집 및 이용 동의</p>
            <table>
              <thead>
                <tr>
                  <th>구분</th>
                  <th>수집, 이용 항목</th>
                  <th>이용 목적</th>
                  <th>보유기간</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>필수 항목</td>
                  <td>성명, 휴대전화번호</td>
                  <td>
                    매장이용 예약 접수, 서비스 이용기록 보관 및 안내, 서비스
                    개선
                  </td>
                  <td>최종 이용 후 2년간 보관</td>
                </tr>
              </tbody>
            </table>
            <br />
            <p>
              필요한 최소한의 개인정보이므로 개인정보 수집에 동의를 해주셔야
              서비스를 이용하실 수 있으며, 동의 거부시 서비스 이용이 제한됩니다.
            </p>
            <br /><br />
            <p class="title">(필수) 이용매장의 개인정보 수집 및 이용 동의</p>
            <table>
              <thead>
                <tr>
                  <th>구분</th>
                  <th>수집, 이용 항목</th>
                  <th>이용 목적</th>
                  <th>보유기간</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>필수 항목</td>
                  <td>성명, 휴대전화번호</td>
                  <td>매장이용 예약 접수, 신규 서비스 제공</td>
                  <td>최종 이용 후 2년간 보관</td>
                </tr>
              </tbody>
            </table>
            <br />
            <p>
              필요한 최소한의 개인정보이므로 개인정보 수집에 동의를 해주셔야
              서비스를 이용하실 수 있으며, 동의 거부시 서비스 이용이 제한됩니다.
            </p>
            <br /><br />
            <p class="title">
              (선택) 이벤트 혜택 알림 및 마케팅 정보 수신 동의
            </p>
            <p>‘테이블링’의 광고성 정보를 수신</p>
            <p>‘이용 매장’의 광고성 정보를 수신</p>
            <template v-if="!isHidePartnerAgree">
            <br /><br />
            <p class="title">
              (선택) 제휴사에 대한 마케팅 정보 수신을 위한 개인정보 수집·이용
              동의
            </p>
            <table>
              <thead>
                <tr>
                  <th>구분</th>
                  <th>수집, 이용 항목</th>
                  <th>이용 목적</th>
                  <th>보유기간</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>선택 항목</td>
                  <td>성명, 휴대전화번호, 이메일주소, 서비스 이용기록</td>
                  <td>
                    제휴사/광고주가 운영하는 상품·서비스·이벤트 등 광고성 정보
                    안내, 서비스 이용 통계 분석 및 타겟팅 마케팅 활용
                  </td>
                  <td>
                    동의일로부터 최대 2년 또는 동의 철회 시까지 (먼저 도래한
                    시점)
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <p>
              본 동의는 선택사항으로 동의하지 않더라도 서비스 이용이 가능하며,
              제휴사/광고주 관련 혜택 및 정보 제공이 제한될 수 있습니다.
              보유기간 경과 또는 동의 철회 시 관련 정보는 지체 없이 파기됩니다.
            </p>
            <br /><br />
            <p class="title">(선택) 제휴사 광고성 정보 수신 동의</p>
            <table>
              <thead>
                <tr>
                  <th>구분</th>
                  <th>수집, 이용 항목</th>
                  <th>이용 목적</th>
                  <th>보유기간</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>선택 항목</td>
                  <td>휴대전화번호, 이메일주소</td>
                  <td>
                    제휴사/광고주가 제공하는 상품·서비스에 대한 광고성 정보
                    발송(카카오톡, SMS, 이메일)
                  </td>
                  <td>
                    동의일로부터 최대 2년 또는 동의 철회 시까지 (먼저 도래한
                    시점)
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <p>
              본 동의는 선택사항으로 동의하지 않더라도 서비스 이용이 가능합니다.
              보유기간 경과 또는 동의 철회 시 관련 정보는 지체 없이 파기됩니다.
            </p>
            <br />
            <p>
              전송되는 광고성 정보에는 제3자의 상품·서비스 정보가 포함될 수
              있으며, 수신 거부 또는 수신동의 철회 방법은 메시지 내에서
              안내됩니다.
            </p>
            </template>
          </div>
        </div>
        <div v-else class="terms">
          <div>
            <p>
              For provision of reservation service, Tabling and stores to which
              a reservation request is submitted collect and use personal
              information as follows:
            </p>
            <br />
            <p class="title">
              (Required) Verification of User’s Age as Being 14 Years of Age or
              Older
            </p>
            <p>
              Children under 14 years of age are restricted to use the service
              for protection of their personal information. Children under 14
              years of age are not allowed to use the service.
            </p>
            <br />
            <p class="title">
              (Required) Consent to Collection and Use of Personal Information
              by ‘Tabling’
            </p>
            <table>
              <thead>
                <tr>
                  <th>Classification</th>
                  <th>Items to be collected and used</th>
                  <th>Purpose of use</th>
                  <th>Retention period</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Required items</td>
                  <td>
                    [Email address]<br />
                    [Name]<br />
                    [Phone Number]
                  </td>
                  <td>
                    Receipt of reservation for use of stores, retention and
                    notification of service use records, improvement of the
                    service
                  </td>
                  <td>For 2 years after final use</td>
                </tr>
              </tbody>
            </table>
            <br />
            <p>
              Since personal information stated as above is minimally required,
              the service can be used only with consent to collection of
              personal information. Refusal to provide consent will result in
              restriction of the use of the service.
            </p>
            <br /><br />
            <p class="title">
              (Required) Consent to Collection and Use of Personal Information
              by Stores
            </p>
            <table>
              <thead>
                <tr>
                  <th>Classification</th>
                  <th>Items to be collected and used</th>
                  <th>Purpose of use</th>
                  <th>Retention period</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Required items</td>
                  <td>
                    [Email address]<br />
                    [Name]<br />
                    [Phone Number]
                  </td>
                  <td>
                    Receipt of reservation for use of stores, provision of new
                    services
                  </td>
                  <td>For 2 years after final use</td>
                </tr>
              </tbody>
            </table>
            <br />
            <p>
              Since personal information stated as above is minimally required,
              the service can be used only with consent to collection of
              personal information. Refusal to provide consent will result in
              restriction of the use of the service.
            </p>
            <br /><br />
            <p class="title">
              (Optional) Consent to Receipt of Event Alarm Message & Marketing
              Information
            </p>
            <p>Receipt of advertising information of ‘Tabling’</p>
            <p>Receipt of advertising information of ‘stores’</p>
            <template v-if="!isHidePartnerAgree">
            <br /><br />
            <p class="title">(Optional) Partner Marketing Data Consent</p>
            <table>
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Items Collected/Used</th>
                  <th>Purpose of Use</th>
                  <th>Retention Period</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Optional</td>
                  <td>
                    Name, mobile phone number, email address, service usage
                    history
                  </td>
                  <td>
                    To provide advertising information such as partner-operated
                    products/services/events, and to use for service statistics
                    analysis and targeted marketing
                  </td>
                  <td>
                    Up to 2 years from the date of consent or until consent is
                    withdrawn, whichever comes first
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <p>
              This consent is optional. You may still use the service even if
              you do not agree; however, partner-related benefits and
              information may be limited. Collected information is destroyed
              without delay when the retention period expires or when consent is
              withdrawn.
            </p>
            <br /><br />
            <p class="title">(Optional) Partner Marketing Consent</p>
            <table>
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Items Collected/Used</th>
                  <th>Purpose of Use</th>
                  <th>Retention Period</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Optional</td>
                  <td>Mobile phone number, email address</td>
                  <td>
                    To send promotional information on partner products/services
                    (KakaoTalk, SMS, Email)
                  </td>
                  <td>
                    Up to 2 years from the date of consent or until consent is
                    withdrawn, whichever comes first
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <p>
              This consent is optional. You may still use the service even if
              you do not agree.
            </p>
            <br />
            <p>
              Advertising messages may include information on third-party
              products/services, and instructions for refusal or withdrawal of
              consent are provided in each message.
            </p>
            </template>
          </div>
        </div>
      </div>
      <div
        class="wating_start_btn"
        :class="{ active: isNextButtonActive }"
        @click="handleingWatingStart"
      >
        {{ $tc("next") }}
      </div>
    </div>
    <!-- <AlertPopup v-show="showAlert" :msg="msg" @AlertEvent="() => { this.showAlert = false }" /> -->
    <div v-show="showAlert" class="alert_wrap">
      <div class="alert_box">
        <div class="alert_msg" v-html="msg"></div>
        <div class="btn_wrap">
          <button
            class="btn_cancel"
            @click="
              () => {
                this.showAlert = false;
              }
            "
          >
            {{ $tc("close") }}
          </button>
          <button class="btn_confirm" @click="agreeAndNext">
            {{ $tc("notice_01_alert_pop_agree") }}
          </button>
        </div>
      </div>
    </div>
    <timeout-popup
      :isShow="isShowTimeOutPop"
      @moveToHome="moveToHome"
      @close="closeTimeoutPopup"
    />
  </div>
</template>

<script>
import { timeout } from './mixins/timeout'
import timeoutPopup from '@/components/TimeOutPopup.vue'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'NoticeView',
  mixins: [timeout],
  components: {
    timeoutPopup
  },
  data () {
    return {
      showAlert: false,
      msg: '',
      allAgree: false,
      agreeList: [
        { value: false, requeired: true },
        { value: false, requeired: true },
        { value: false, requeired: false },
        { value: false, requeired: false },
        { value: false, requeired: false }
      ]
    }
  },
  computed: {
    ...mapState(['restaurant', 'locale']),
    ...mapGetters({
      restaurant: 'getRestaurantInfo',
      waitingParams: 'getWaitingParams'
    }),
    isHidePartnerAgree () {
      return process.env.VUE_APP_HIDE_PARTNER_AGREE && process.env.VUE_APP_HIDE_PARTNER_AGREE.includes(this.restaurant.idx)
    },
    isNextButtonActive () {
      const idx = this.agreeList.findIndex(
        data => !data.value && data.requeired
      )
      return idx === -1
    }
  },
  methods: {
    agreeAndNext () {
      this.handleingAgree('allAgree')
      this.handleingWatingStart()
    },
    handleingWatingStart () {
      if (this.isNextButtonActive) {
        const waitingParams = {
          isAgreement: this.isNextButtonActive,
          isMarketing: this.agreeList[2].value,
          isThirdParty: false,
          isPartnerInfoAgreement: this.agreeList[3].value,
          isPartnerAdAgreement: this.agreeList[4].value
        }
        // this.$store.commit('waitingParams', waitingParams)
        this.$store.commit('setWaitingParams', waitingParams)
        // const goPath = (this.restaurant.nameRequired) ? '/privacy' : '/phone'
        let goPath = this.restaurant.nameRequired ? '/privacy' : '/phone'
        if (
          this.locale !== 'ko' &&
          this.restaurant.foreignRequestType &&
          this.restaurant.foreignRequestType.length > 0
        ) {
          goPath = '/bifurcation'
        }
        this.$router.push(goPath)
      } else {
        this.showAlert = true
        this.msg = this.$tc('accept_space')
      }
    },
    handleingAgree (target, idx = -1) {
      const targetVal =
        target === 'allAgree' ? !this.allAgree : !this.agreeList[idx].value
      if (target === 'allAgree') {
        this.allAgree = targetVal
        this.agreeList = this.agreeList.map((agree, i) => {
          agree.value = this.isHidePartnerAgree && (i === 3 || i === 4) ? false : targetVal
          return agree
        })
      } else {
        let falseCnt = 0
        this.agreeList = this.agreeList.map((agree, i) => {
          if (i === idx) {
            agree.value = targetVal
          }
          if (this.isHidePartnerAgree && (i === 3 || i === 4)) {
            return agree
          }
          falseCnt = agree.value ? falseCnt : falseCnt + 1
          return agree
        })
        this.allAgree = falseCnt === 0
      }
    },
    back () {
      this.$router.push('/')
    }
  },
  mounted () {
    const { isAgreement, isMarketing, isPartnerInfoAgreement, isPartnerAdAgreement } = this.waitingParams
    let falseCnt = 0
    this.agreeList = this.agreeList.map((agree, idx) => {
      if (idx < 2) {
        agree.value = isAgreement
      }
      if (idx === 2) {
        agree.value = isMarketing
      }
      if (idx === 3) {
        agree.value = !!isPartnerInfoAgreement
      }
      if (idx === 4) {
        agree.value = !!isPartnerAdAgreement
      }
      if (this.isHidePartnerAgree && (idx === 3 || idx === 4)) {
        return agree
      }
      falseCnt = agree.value ? falseCnt : falseCnt + 1
      return agree
    })
    this.allAgree = falseCnt === 0
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/base.scss";

.inner_wrap {
  display: block;

  .terms_warp {
    display: flex;
    justify-content: center;
    @include flex-gap(5vh, row);
    padding: 6.25vh 7.03125vw;
    .check_box_list_wrap {
      overflow-y: auto;
      max-height: 67vh;
    }
    .check_box_list {
      width: 46.875vw;
      li {
        display: flex;
        align-items: flex-start;
        @include flex-gap(2vh, row);
        padding: 1.5vh 1.5625vw;
        .agree_str {
          color: #2e3137;
          font-size: 24px; // IE11 fallback
          font-size: unquote("min(1.875vw, 24px)");
          font-weight: 600;
          line-height: 5vh;
        }
        &.all_agree .agree_str {
          color: #000;
          font-size: 28px; // IE11 fallback
          font-size: unquote("min(2.1875vw, 28px)");
          font-weight: 700;
        }
      }
      .check-box {
        flex-shrink: 0;
        display: flex;
        align-items: baseline;
        justify-content: center;
        width: 2.5vw;
        height: 4vh;
        border-radius: 1vh;
        background: $gray_400;
        margin: 0.5vh;
        &.active {
          background: #d81b1b;
        }
        &::after {
          content: "";
          display: block;
          width: 2.5vw;
          height: 4vh;
          background: url("~@/assets/img/white/check.svg") no-repeat center
            center;
        }
      }
    }
    .terms {
      display: flex;
      width: 35.9375vw;
      min-width: 35.9375vw;
      height: 67vh;
      padding: 3vh 2.1875vw;
      flex-direction: column;
      align-items: center;
      color: #2e3137;
      font-size: 18px; // IE11 fallback
      font-size: unquote("min(1.40625vw, 18px)");
      font-weight: 500;
      line-height: 3.5vh;
      overflow-y: scroll;
      border-radius: 24px;
      border: 1px solid #d7dbdf;
      background: #fff;
      table {
        width: 100%;
        table-layout: fixed;
        border-collapse: collapse;
      }
      th,
      td {
        text-align: center;
        border: 2px solid #d7dbdf;
        overflow-wrap: break-word;
        word-break: break-word;
      }
      th:nth-child(1),
      td:nth-child(1) {
        width: 18%;
      }
      th:nth-child(n + 2),
      td:nth-child(n + 2) {
        width: calc((100% - 18%) / 3);
      }
    }
  }
  .wating_start_btn {
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 94px;
    background: #b7bec8;
    color: rgba(255, 255, 255, 0.59);
    font-size: 36px; // IE11 fallback
    font-size: unquote("min(2.8125vw, 36px)");
    font-weight: 700;
    line-height: 1.05;
    &.active {
      cursor: pointer;
      color: #ffffff;
      background-color: #d81b1b;
    }
  }
}
.alert_wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 999;
  background: rgba(0, 0, 0, 0.6);
  .alert_box {
    display: flex;
    flex-direction: column;
    @include flex-gap(5vh, column);
    width: 66.40625vw;
    padding: 7.5vh 3.90625vw 6.25vh;
    background: $white;
    border-radius: 4vh;
    border: 1px solid #e0e0e0;
    .alert_msg {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 19.875vh;
      color: $black;
      text-align: center;
      font-size: 36px; // IE11 fallback
      font-size: unquote("min(2.8125vw, 36px)");
      font-weight: 700;
      line-height: 6.625vh;
    }
    .btn_wrap {
      display: flex;
      @include flex-gap(2.5vh, row);
      width: 100%;
      button {
        display: flex;
        height: 11.75vh;
        width: 100%;
        padding: 3.5vh 0.78125vw;
        justify-content: center;
        align-items: center;
        color: $gray_800;
        text-align: center;
        font-size: 32px; // IE11 fallback
        font-size: unquote("min(2.5vw, 32px)");
        font-weight: 700;
        line-height: 4.75vh;
        border: none;
        border-radius: 2.5vh;
        background: #e6e8eb;
        &.btn_confirm {
          background: #d81b1b;
          color: $white;
        }
      }
    }
  }
}
</style>
